import { DtoBase } from "@models/base/dtoBase.model";
import { ExpedienteSummaryDto } from "@models/expediente/expedienteSummary.model";
import { UsuarioSummaryDto } from "@models/usuario/usuarioSummaryDto.model";

// Definimos la clase TimeSpan como una representación de la duración de tiempo
class TimeSpan {
  horas: number;
  minutos: number;
  segundos: number;

  constructor(horas: number = 0, minutos: number = 0, segundos: number = 0) {
    this.horas = horas;
    this.minutos = minutos;
    this.segundos = segundos;
  }
}


// Clase EventoAgendaDto que representa la estructura de un evento en la agenda
export class EventoAgendaDto extends DtoBase {
  titulo!: string ;
  observaciones!: string ;
  fechaInicio!: string;
  fechaFin!: string ;
  horaInicio!: string;
  horaFin!: string ;
  esTodoElDia!: boolean;
  url!: string ;
  classNames!: string ;
  className!: string ;
  esEditable!: boolean;
  colorFondo!: string ;
  colorBorde!: string ;
  colorTexto!: string ;
  expediente!: ExpedienteSummaryDto ;
  prioridad!: number ;
  nivelAvance!: number ;
  comentarios!: string ;
  lugar!: string ;
  recordatorio!: TimeSpan ;
  esRecurrente!: boolean ;
  frecuenciaRecurrente!: string ;
  duracion!: TimeSpan ;

  estadoEventoAgenda!: DtoBase;  // Conservado si ya lo estás usando como clase base
  tipoEventoAgenda!: DtoBase;
  esAvisoAPartes!: boolean;
  avisoNMinutosAntes!: number ;
  asignadoA!: UsuarioSummaryDto
  creadoPor!: UsuarioSummaryDto
  modificadoPor!: UsuarioSummaryDto
  diasSemana!: string;
  unidadRepeticion!: string;
  esEventoPresencial!: boolean;
  zonaHoraria!: string;

  constructor() {
    super();
    this.className = this.classNames;
  }

}
